const EDIT_APP_NOTICE_DRAFT_PREFIX = 'admin:appNoticeDraft:edit:'
export const NEW_APP_NOTICE_DRAFT_KEY = 'admin:appNoticeDraft:new'

const APP_NOTICE_DRAFT_FIELDS = [
    'deviceType',
    'cCode',
    'title',
    'content',
    'status',
    'popupStatus',
    'startTime',
    'endTime',
]

const getSessionStorage = () => {
    if (typeof window === 'undefined') {
        return null
    }

    try {
        return window.sessionStorage
    } catch (_error) {
        // 브라우저 정책으로 storage 접근이 막혀도 공지사항 작성 화면은 계속 동작한다.
        return null
    }
}

const serializeDateValue = (value) => {
    if (value === null) {
        return null
    }

    if (value === undefined || value === '') {
        return ''
    }

    const nextDate = new Date(value)

    return Number.isNaN(nextDate.getTime()) ? '' : nextDate.toISOString()
}

const parseDateValue = (value, fallbackValue) => {
    if (value === null) {
        return null
    }

    if (value === undefined || value === '') {
        return fallbackValue
    }

    const nextDate = new Date(value)

    return Number.isNaN(nextDate.getTime()) ? fallbackValue : nextDate
}

// App 공지사항 폼에서 실제로 다시 입력해야 하는 값만 sessionStorage에 남긴다.
export const createAppNoticeDraftPayload = ({ params = {}, push = 0 }) => {
    return {
        params: {
            deviceType: params.deviceType || 'all',
            cCode: params.cCode || 'kr',
            title: params.title || '',
            content: params.content || '',
            status: params.status ?? 0,
            popupStatus: params.popupStatus ?? 0,
            startTime: serializeDateValue(params.startTime),
            endTime: serializeDateValue(params.endTime),
        },
        push: push ?? 0,
    }
}

// 서버 기본값 위에 draft만 덮어써서 새로고침 뒤에도 작성 흐름을 이어간다.
export const applyAppNoticeDraft = ({ baseParams = {}, basePush = 0, draft }) => {
    if (!draft) {
        return {
            params: baseParams,
            push: basePush,
        }
    }

    const draftParams = draft.params || {}
    const nextParams = {
        ...baseParams,
    }

    APP_NOTICE_DRAFT_FIELDS.forEach((field) => {
        if (draftParams[field] === undefined) {
            return
        }

        if (field === 'startTime' || field === 'endTime') {
            nextParams[field] = parseDateValue(draftParams[field], baseParams[field] ?? null)
            return
        }

        nextParams[field] = draftParams[field]
    })

    return {
        params: nextParams,
        push: draft.push ?? basePush,
    }
}

export const createEditAppNoticeDraftKey = (noticeId) => `${EDIT_APP_NOTICE_DRAFT_PREFIX}${noticeId}`

export const readAppNoticeDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return null
    }

    try {
        const storedValue = storage.getItem(draftKey)
        return storedValue ? JSON.parse(storedValue) : null
    } catch (_error) {
        return null
    }
}

export const saveAppNoticeDraft = (draftKey, draftValue) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.setItem(draftKey, JSON.stringify(draftValue))
    } catch (_error) {
        // sessionStorage가 막혀 있어도 작성 흐름은 그대로 유지한다.
    }
}

export const clearAppNoticeDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.removeItem(draftKey)
    } catch (_error) {
        // storage 정리에 실패해도 화면 동작은 계속 진행한다.
    }
}
